module.exports = __webpack_public_path__ + "img/requestedIcon.bbc421e2.svg";